<template>
    <div class="notice">
        <div class="top-area">
            <div class="w3-row">
                <div class="w3-col s12">
                    <img v-if="$i18n.locale === 'ko'" src="@/static/img/kr/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'vi'" src="@/static/img/vn/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'my'" src="@/static/img/mm/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'ne'" src="@/static/img/np/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'uz'" src="@/static/img/uz/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'lk'" src="@/static/img/lk/loan_check_list.png" class="w3-image">
                    <img v-else-if="$i18n.locale === 'kh'" src="@/static/img/kh/loan_check_list.png" class="w3-image">
                    <img v-else src="@/static/img/us/loan_check_list.png" class="w3-image">
                </div>
            </div>
        </div>
        <div class="middle-area">
            <div class="w3-row">
                <div class="w3-col s12">
                    <p class="w3-center" style="font-weight:bold;padding:1px;">
                        <span style="vertical-align:middle;margin-right:5px;">{{ $t('notice.text.loanConsult') }}</span>
                        <img src="../static/img/common/circle_checkbox.png" style="height:20px;width:20px;vertical-align:middle;">
                    </p>
                </div>
            </div>

            <CustomerCenter ></CustomerCenter>

            <div class="w3-row">
                <div class="w3-col s12">
                    <p class="w3-center" style="padding:1px;">
                        <img src="@/static/img/common/clock_icon.png" style="height:20px;width:20px;vertical-align:middle;margin-right:5px;">
                        <span style="vertical-align:middle;">{{ $t('notice.text.workTime') }}</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="bottom-area">
            <div class="w3-row">
                <div class="w3-col s12" style="padding:0px 0px;">
                    <button class="w3-button w3-white w3-border-bottom btn-document" v-on:click="nextPage()">
                        <img src="../static/img/common/doc_check_list.png" style="height:20px;width:20px;margin-right:5px;vertical-align:middle;">
                        {{ $t('notice.text.showDocument') }}
                    </button>
                </div>
            </div>
            <div class="w3-row" style="margin-top:10px;">
                <div class="w3-col s12">
                    <span class="" style="font-size:14px;">{{ $t('notice.text.supportNotice') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

.dot {
    height: 26px;
    width: 26px;
    background-color: #3db087;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 12px;
}

.top-area {
    background: #3db087;
    min-height: 400px;
}
.sub-title{
    background: #29a67a;
    color: #ffffff;
    padding: 5px 0px;
}

.notice-area {
    background: #ffffff;
    border-radius: 10px;
    min-height: 100px;
    margin: 16px;
    padding: 10px 0px;
}

.middle-area {
    background: #f7f7f7;
}

.bottom-area {
    color: #000000;
    background: #ffffff;
    padding: 10px 0px;
}

.btn-document {
    font-size: 13px;
    font-weight: 600;
    padding: 3px 0px;
}

/* .cs-image {
    height: 50px;
    width: 50px;
}
 */
</style>
<script>
import CustomerCenter from '@/components/CustomerCenter.vue'

export default {
  name: 'notice',
  components: {
    CustomerCenter
  },
  methods: {
    nextPage: function () {
      this.$router.push({ name: 'Document' }, function () {
        // console.log('nextPage')
      })
    }
  }
}
</script>
